export const SUPPORT_LANGUAGES = ['en', 'de', 'fr']